module.exports = __webpack_public_path__ + "static/media/chiks_moving.6ecb6ba8.gif";